// Footers (STYLE 4). App: "{appName} · Help: {supportEmail}". Public: ©, the
// legal links and "Data stays in the EU".
import { Link } from "react-router";
import { useMeta } from "../api/meta";

export function AppFooter() {
  const meta = useMeta();
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <p>
          {meta.appName} · Help: <a href={`mailto:${meta.supportEmail}`}>{meta.supportEmail}</a>
        </p>
      </div>
    </footer>
  );
}

const isInternal = (url: string) => url.startsWith("/");

function LegalLink({ url, children }: { url: string; children: string }) {
  return isInternal(url) ? <Link to={url}>{children}</Link> : <a href={url}>{children}</a>;
}

export function PublicFooter() {
  const meta = useMeta();
  return (
    <footer className="site-footer site-footer--public">
      <div className="site-footer__inner">
        <p>
          © {new Date().getFullYear()} {meta.appName} · Made in Europe for Europe
        </p>
        <ul className="site-footer__links">
          <li>
            <LegalLink url={meta.privacyUrl}>Privacy notice</LegalLink>
          </li>
          <li>
            <LegalLink url={meta.termsUrl}>Terms</LegalLink>
          </li>
          <li>
            <LegalLink url={meta.accessibilityUrl}>Accessibility</LegalLink>
          </li>
          <li>Data stays in the EU</li>
        </ul>
      </div>
    </footer>
  );
}
